export default "__VITE_ASSET__66666779__"